import {
  CDN_GCS,
  DOMAIN_CDN,
  DOMAIN_IMAGE_CACHE_LOADER,
  GCS_HOST,
  GCS_IMAGE,
  GG_IMAGE,
  PROXY_IMAGE,
  WEB_HOST,
} from 'sysconfig';

// Các host nguồn của ảnh trên storage — link thuộc các host này sẽ được quy về GCS_HOST.
// Link không thuộc host nào ở đây (ảnh static /images, WEB_HOST, CDN khác...) giữ nguyên.
const IMAGE_SOURCE_HOSTS = [
  GG_IMAGE,
  GCS_IMAGE,
  PROXY_IMAGE,
  DOMAIN_IMAGE_CACHE_LOADER,
  CDN_GCS,
  GCS_HOST,
].filter(Boolean);

// Tham khảo convertImage của internal-wms-app.
// URL format: <GCS_HOST>/<bucket>/<path-to-object>?<parameters>
// Params hỗ trợ: width, height, quality (1 - 100) - đều optional.
export const convertImage = ({ url = null, width = null, height = null, quality = null } = {}) => {
  if (!url) return url;

  const sourceHost = IMAGE_SOURCE_HOSTS.find((host) => url.startsWith(host));
  if (!sourceHost) return url;

  const path = url.replace(sourceHost, '').replace(/^\/+/, '');

  const params = [];
  if (width) params.push(`width=${width}`);
  if (height) params.push(`height=${height}`);
  if (quality) params.push(`quality=${quality}`);
  const query = params.length ? `${path.indexOf('?') >= 0 ? '&' : '?'}${params.join('&')}` : '';

  return `${GCS_HOST}/${path}${query}`;
};

// storage có thể chứa file tên có khoảng trắng -> encode trước khi convert
const encodeImageUrl = (url = null) => url && encodeURI(url.replace(/\s/g, '%20'));

// getLinkCDNGCS xử lý file (không phải ảnh) -> chỉ quy host nguồn về CDN_GCS, giữ nguyên path.
// Khác convertImage (xử lý ảnh: quy về GCS_HOST và append params width/height/quality).
const convertToCDNGCS = (url = null) => {
  if (!url || !CDN_GCS) return url;

  const sourceHost = IMAGE_SOURCE_HOSTS.find((host) => url.startsWith(host));
  if (!sourceHost) return url;

  const path = url.replace(sourceHost, '').replace(/^\/+/, '');
  return `${CDN_GCS}/${path}`;
};

export const getLinkProxy = (url = '', { width = null, height = null, quality = null } = {}) =>
  convertImage({ url, width, height, quality });
export const getLinkGCS = (url = '', { width = null, height = null, quality = null } = {}) =>
  convertImage({ url, width, height, quality });
export const getLinkCDNGCS = (url = '') => convertToCDNGCS(url);

export const getLinkCacheProxy = ({
  url = null,
  size = 'origin',
  q = 100,
  w = null,
  h = null,
  isEmpty = false,
}) => {
  if (isEmpty) {
    return convertImage({ url });
  }

  return convertImage({ url, width: w || size, height: h, quality: q });
};

export const getLinkCacheProxyProduct = (img) => getLinkCacheProxy({ url: img, isEmpty: true });

// thuannc change cache-image
// url đã convert về GCS_HOST (hoặc thuộc web host / CDN riêng) thì giữ nguyên, tránh append params trùng
export const getProxyImageList = (images = [], size = '') =>
  images?.map((url) =>
    url?.startsWith(GCS_HOST) ||
    (WEB_HOST && url?.startsWith(WEB_HOST)) ||
    (DOMAIN_CDN && url?.startsWith(DOMAIN_CDN))
      ? url
      : convertImage({ url, width: size || null }),
  ) || [];

export const blobToBase64 = (blob) =>
  new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });

export const getLinkProxyVideo = (url = null) => convertImage({ url: encodeImageUrl(url) });
export const getLinkProxyFile = (url = null) => convertImage({ url: encodeImageUrl(url) });

export const getLinkProxyCDN = (url = null, { width = null, height = null, quality = null } = {}) =>
  convertImage({ url: encodeImageUrl(url), width, height, quality });
export const getLinkProxyCDNFallback = (
  url = null,
  { width = null, height = null, quality = null } = {},
) => convertImage({ url: encodeImageUrl(url), width, height, quality });
